// CORE
import React, { Component } from 'react';

// USER DEFINED
import Routes from 'Routes/Route';
import { ContentWrapper } from './Website.style';
import EventManager from './EventManager/EventManager';

/**
 * @component
 * @description Main website component that serves as the primary content container.
 * This component acts as the root layout wrapper that contains the routing system
 * and global event management. It provides the structural foundation for the entire
 * application content area.
 *
 * The component includes:
 * - Main routing system via Routes component
 * - Global event management via EventManager
 * - Styled content wrapper for consistent layout
 *
 * @extends React.Component
 * @returns {JSX.Element} The main website structure with routes and event management
 *
 * @example
 * // Used in App.js
 * import Website from './Components/Website';
 *
 * function App() {
 *   return (
 *     <Provider store={store}>
 *       <BrowserRouter>
 *         <MuiThemeProvider theme={theme}>
 *           <Website />
 *         </MuiThemeProvider>
 *       </BrowserRouter>
 *     </Provider>
 *   );
 * }
 *
 * @see Routes - Main routing component
 * @see EventManager - Global event and notification manager
 * @see ContentWrapper - Styled wrapper component
 */
class Website extends Component {
    /**
     * @method
     * @description Renders the main website structure.
     *
     * @returns {JSX.Element} Website layout with routes and event management
     */
    render() {
        return (
            <React.Fragment>
                <ContentWrapper>
                    <Routes />
                </ContentWrapper>
                <EventManager />
            </React.Fragment>
        );
    }
}

export default Website;
